import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initAuthFromUrl } from './auth/tokenService';

const root = ReactDOM.createRoot(document.getElementById('root'));

// TEMP: access gate disabled — restore verifyFlyerAccess + AccessDeniedScreen when re-enabling auth.
initAuthFromUrl()
  .catch(() => {})
  .then(() => {
    root.render(<App />);
  });
